import { useI18n } from '@udemy/i18n';
import { Icon } from '@udemy/icons';
import React from 'react';
import { Ribbon } from './ribbon.react-component';

/**
 * COURSE RIBBONS
 */

/*
 * ### Bestseller Ribbon
 */
export const BestsellerRibbon = props => {
  const {
    gettext
  } = useI18n();
  return /*#__PURE__*/React.createElement(Ribbon, Object.assign({
    color: "teal-150"
  }, props), gettext('Bestseller'));
};
/*
 * ### Highest Rated Ribbon
 */

export const HighestRatedRibbon = props => {
  const {
    gettext
  } = useI18n();
  return /*#__PURE__*/React.createElement(Ribbon, Object.assign({
    color: "orange-150"
  }, props), gettext('Highest Rated'));
};
/*
 * ### Hot & New Ribbon
 */

export const HotAndNewRibbon = props => {
  const {
    gettext
  } = useI18n();
  return /*#__PURE__*/React.createElement(Ribbon, Object.assign({
    color: "red-150"
  }, props), gettext('Hot & New'));
};
/*
 * ### New Ribbon
 */

export const NewRibbon = props => {
  const {
    gettext
  } = useI18n();
  return /*#__PURE__*/React.createElement(Ribbon, Object.assign({
    color: "green-150"
  }, props), gettext('New'));
};
/**
 * PRODUCT RIBBONS
 */

export const AlphaRibbon = props => {
  const {
    gettext
  } = useI18n();
  return /*#__PURE__*/React.createElement(Ribbon, props, gettext('Alpha'));
};
export const BetaRibbon = props => {
  const {
    gettext
  } = useI18n();
  return /*#__PURE__*/React.createElement(Ribbon, props, gettext('Beta'));
};
export const NewFeatureRibbon = props => {
  const {
    gettext
  } = useI18n();
  return /*#__PURE__*/React.createElement(Ribbon, Object.assign({
    color: "purple-150"
  }, props), /*#__PURE__*/React.createElement(Icon, {
    color: "inherit",
    label: false,
    glyph: "trending-flame",
    size: "xxxsmall"
  }), gettext('New Feature'));
};
export const ProRibbon = props => {
  const {
    gettext
  } = useI18n();
  return /*#__PURE__*/React.createElement(Ribbon, Object.assign({}, props, {
    color: "green-350"
  }), /*#__PURE__*/React.createElement(Icon, {
    color: "inherit",
    label: false,
    glyph: "rating-star",
    size: "xxxsmall"
  }), gettext('Pro'));
};
//# sourceMappingURL=applied-ribbon.react-component.js.map